var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardWrap"},[(_vm.title)?_c('div',{staticClass:"cardTitle"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("title"),_c('div',{staticClass:"cardContent mt5"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }